// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"style_loginPage__2bJwI","loginContainer":"style_loginContainer__1BWjQ","logo":"style_logo__3tCYA","forgotPass":"style_forgotPass__1xYTt"};